webpackJsonp([6],{

/***/ 1705:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 816:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_promise_polyfill__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_promise_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_form_service_frontend_lib_assets_sass_main_scss__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_form_service_frontend_lib_assets_sass_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_form_service_frontend_lib_assets_sass_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_form_service__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_form_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_form_service__);





if (!window.Promise) {
  window.Promise = __WEBPACK_IMPORTED_MODULE_1_promise_polyfill___default.a;
}

if (false) {
  module.hot.accept();
}

if (false) {
  throw new Error('Enviroment variable NODE_ENV_SETTINGS not specified');
}

var formServiceUrl = void 0;
var OAUTHUrl = void 0;
var OAUTHRedirectUrl = void 0;
var PrimaryAuthUrl = void 0;

// Удалить после первой успешной сборки на develop и на production
console.log('NODE_ENV_SETTINGS', "production");

if (false) {
  formServiceUrl = 'https://forms.dev.jlr.perx.ru/forms/api/v1';
  OAUTHUrl = 'https://forms.dev.jlr.perx.ru/auth';
  OAUTHRedirectUrl = 'https://forms.dev.jlr.perx.ru';
  PrimaryAuthUrl = 'http://dev.lr-dealers.ru/forms_service/';
} else {
  formServiceUrl = 'https://forms.jlr-connect.com/forms/api/v1';
  OAUTHUrl = 'https://forms.jlr-connect.com/auth';
  OAUTHRedirectUrl = 'https://forms.jlr-connect.com';
  PrimaryAuthUrl = 'http://master.prod.lr-dealers.ru/forms_service';
}

__WEBPACK_IMPORTED_MODULE_3_form_service___default()({
  appId: 'form-service-admin',
  formServiceUrl: formServiceUrl,
  statuses: ['Выполнен', 'Отложен'],
  auth: {
    OAUTHUrl: OAUTHUrl,
    OAUTHRedirectUrl: OAUTHRedirectUrl,
    OAUTHClientId: 'FormServiceJWTClient',
    OAUTHSecret: 'ZTNiMGM0NDI5OGZjMWMxNDlhZmJmNGM4',
    isImplicit: true
  }
});

/***/ })

},[816]);


// WEBPACK FOOTER //
// formAdmin.js